import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c65138a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65138a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c65138a')) {
      api.createRecord('5c65138a', component.options)
    } else {
      api.reload('5c65138a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c65138a&scoped=true", function () {
      api.rerender('5c65138a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/activity/index.vue"
export default component.exports